import { render } from "./info_on.vue?vue&type=template&id=047d0cc4"
import script from "./info_on.vue?vue&type=script&lang=js"
export * from "./info_on.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__